module.exports = __webpack_public_path__ + "img/HP_00_mono_AE_00005.2a4be746.png";